import { useWeb3ModalProvider } from '@web3modal/ethers5/react';
import { ethers } from 'ethers';
import { useState, useEffect } from 'react';


export default function useEthersSigner() {
  const { walletProvider } = useWeb3ModalProvider();
  const [signer, setSigner] = useState(null);

  useEffect(() => {
    if (walletProvider) {
      const provider = new ethers.providers.Web3Provider(walletProvider, "any");
      const signerInstance = provider.getSigner();
      setSigner(signerInstance);
    } else {
      setSigner(null);
    }
  }, [walletProvider]);

  return signer;
}
